import { connect } from 'react-redux';
import React, { useState } from 'react';

import { updateOrder } from 'actions/orders';
import { errorInputClear } from 'actions/error';
import { addressSelector } from 'selectors/order-create';

import Card from 'components/common/Card';
import Select from 'components/SelectInput';
import AddressLookup from '../AddressLookup';
import TextInput from 'components/TextInput';
import LoadingSpinner from 'components/LoadingSpinner';
import Notice from 'components/Notice';
import {
  FlexItem,
  StepTitle,
  ContentContain,
  InputContainer,
  StepInformation,
  StepSubTitle,
  LoadingContain
} from '../CreateStyled';

import { stepAddress as handleValidate } from '../validation/';

export const AddressFields = ({
  values,
  onChange,
  inputErrors,
  onSelectChange
}) => {
  return (
    <div>
      <InputContainer>
        <FlexItem minWidth={200} maxWidth={200}>
          <TextInput
            bold
            label="Unit No"
            name="address_unit"
            onChange={onChange}
            placeholder="Unit Number"
            value={values.address_unit}
            errorText={inputErrors.address_unit}
          />
        </FlexItem>
        <FlexItem minWidth={200} maxWidth={200}>
          <TextInput
            bold
            label="Street No"
            name="address_street_no"
            onChange={onChange}
            placeholder="Street Number"
            value={values.address_street_no}
            errorText={inputErrors.address_street_no}
          />
        </FlexItem>
        <div style={{ height: 70, display: 'flex', alignItems: 'center', padding: '0em 0.5em' }}>
          OR
        </div>
        <FlexItem minWidth={200} maxWidth={200}>
          <TextInput
            bold
            label="Lot No"
            name="address_lot"
            onChange={onChange}
            placeholder="Lot Number"
            value={values.address_lot}
            errorText={inputErrors.address_lot}
          />
        </FlexItem>
      </InputContainer>
      <TextInput
        bold
        required
        label="Street Address 1"
        name="address_street_1"
        onChange={onChange}
        placeholder="Street Address 1"
        value={values.address_street_1}
        errorText={inputErrors.address_street_1}
      />
      <TextInput
        bold
        label="Street Address 2"
        name="address_street_2"
        onChange={onChange}
        placeholder="Street Address 2"
        value={values.address_street_2}
        errorText={inputErrors.address_street_2}
      />

      <InputContainer>
        <FlexItem flex={3}>
          <TextInput
            bold
            required
            label="Suburb"
            name="address_suburb"
            placeholder="Suburb"
            onChange={onChange}
            value={values.address_suburb}
            errorText={inputErrors.address_suburb}
          />
        </FlexItem>

        <FlexItem flex={1}>
          <Select
            label="State"
            required
            name="address_state"
            onChange={onSelectChange}
            value={values.address_state}
            errorText={inputErrors.address_state}
          >
            <option value="" />
            <option value="NSW">NSW</option>
            <option value="QLD">QLD</option>
            <option value="SA">SA</option>
            <option value="TAS">TAS</option>
            <option value="VIC">VIC</option>
            <option value="WA">WA</option>
            <option value="ACT">ACT</option>
            <option value="NT">NT</option>
          </Select>
        </FlexItem>

        <FlexItem flex={1}>
          <TextInput
            bold
            required
            label="Postcode"
            onChange={onChange}
            name="address_postcode"
            value={values.address_postcode}
            placeholder="Postcode"
            errorText={inputErrors.address_postcode}
          />
        </FlexItem>
      </InputContainer>
    </div>
  );
}

export const StepAddress = ({
  orderType,
  updateOrder,
  inputErrors,
  supportedStates,
  onValueChange,
  addressValues,
  renderActions,
  loadingAddresses
}) => {

  const [state, setState] = useState({ ...addressValues });

  const handleNext = () => {
    const updated = { 
      ...state,
      order_title: false,
      globalx_meta: null,
      title_addresses: [],
      globalx_address_display: ''
    };

    updateOrder(updated);
    return handleValidate(updated);
  };

  const handleChange = (name, value) => {
    onValueChange(name, value);
    setState((values) => ({ ...values, [name]: value }));
  };

  const onAddressSelect = (data) => {
    setState(data);
  };

  const handleSelectChange = (e) => handleChange(e.target.name, e.target.value);
       // color={type === 'warning' ? Theme.warningColor : Theme.dangerColor}
       //    fontWeight={400}
       //    text={message.error || message}
       //    secondaryColor={
       //      type === 'warning' ? Theme.warningColorLight : Theme.dangerColorLight
       //    }
  function renderNotice () {
    var addState = (state.address_state || '').toUpperCase();

    if (addState && !supportedStates.includes(addState)) {
      return (
        <div style={{ paddingBottom: '1rem' }}>
          <Notice 
            secondaryColor="#fffbeb" 
            color="#fbbf24" 
            text={<span style={{ fontSize: '0.875rem', color: '#d97706' }}><span style={{ color: '#b45309', fontWeight: 500 }}>* Please Note </span>Only <span style={{ color: '#b45309', fontWeight: 500 }}>{supportedStates.join(', ')}</span> addresses are currently supported for this order type</span>} 
          />
        </div>
      )
    }

    return null;
  }

  return (
    <React.Fragment>
      {renderNotice()}
      <Card.Content>
        <ContentContain>
          <StepTitle>Property Details</StepTitle>
          <StepInformation>Enter the property address below</StepInformation>

          <StepSubTitle>Address Lookup</StepSubTitle>
          <AddressLookup onSelect={onAddressSelect} />

          {
            loadingAddresses &&
            <LoadingContain>
              <LoadingSpinner />
            </LoadingContain>
          }

          <StepSubTitle>Address Details</StepSubTitle>

          <AddressFields 
            values={state}
            onChange={handleChange}
            inputErrors={inputErrors}
            onSelectChange={handleSelectChange}
          />

          {renderActions({ hideBack: true, onNext: handleNext })}
        </ContentContain>
      </Card.Content>
    </React.Fragment>
  );
};

StepAddress.defaultProps = {
  inputErrors: {},
  onValueChange: () => null
};

export default connect(
  (state) => ({
    order: state.pendingOrder.pending,
    inputErrors: state.error.inputErrors,
    orderAddress: addressSelector(state),
    loadingAddresses: state.loading.loadingAddresses
  }),
  {
    dispatchOrderUpdate: updateOrder,
    dispatchErrorInputClear: errorInputClear
  }
)(props => 
  <StepAddress {...props}
    addressValues={props.orderAddress}
    fileNumber={props.order.file_number}
    updateOrder={props.dispatchOrderUpdate}
    onValueChange={props.dispatchErrorInputClear}
  />
);
